import { matchCodeUrl } from '@/constants/urls';
import searchTabTemplate from './searchTabTemplate';

export default searchTabTemplate(matchCodeUrl(['searches']), ({ search }) => search.read);
